import React from 'react'
import { ReactComponent as LogoSeguro } from '../../images/logo-fundo-branco.svg'
import Button from '../button/index'
import { CadastroWrapper } from './style'
import globals from '../globals'

const ChamadaCadastro = props => {
  const fazerCadastro = (e) => {
    e.preventDefault();
    window.location.replace(globals.LINK_CADASTRO);
    return false;
  }
  return (
    <CadastroWrapper>
      <LogoSeguro />
      <h4>
        <b>Imobiliárias e Corretores de Locação</b> podem oferecer o Seguro Residencial, basta se cadastrar na plataforma CredPago. Se você ainda não é cadastrado, clique no botão abaixo. É grátis!
      </h4>
      <Button onClick={fazerCadastro} type="inverted">
        Fazer Cadastro na CredPago
      </Button>
    </CadastroWrapper>
  )
}
export default ChamadaCadastro